import { FETCH_FILTERS_PARAM_SUCCESS } from '../actions'

const kamUsers = (state = [], action) => {
  switch (action.type) {
    case FETCH_FILTERS_PARAM_SUCCESS:
      return action.kamUsers
    default:
      return state
  }
}

export default kamUsers

export const getKamUsers = (state) => state.kamUsers
